import { render } from "./KeepBar.vue?vue&type=template&id=79df74eb"
import script from "./KeepBar.vue?vue&type=script&lang=js"
export * from "./KeepBar.vue?vue&type=script&lang=js"

import "./KeepBar.vue?vue&type=style&index=0&id=79df74eb&lang=css"

import exportComponent from "/builds/platform/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__